export { default } from './RecentlyReturnedItem';



// WEBPACK FOOTER //
// ./app/components/borrowing/recentlyreturned/RecentlyReturnedItem/index.js